import { GET_DETAIL_EXPERIENTIAL_LEARNING, GET_DETAIL_SOCIAL_LEARNING } from "@/api/idp/course-completion";
import {
  SUBMIT_IDP_LEARNING,
  GET_DETAIL_STRUCTURED_LEARNING,
  GET_LIST_IDP_LEARNING,
  GET_SUMMARY_IDP_LEARNING,
  GET_IDP_PERIOD,
  GET_SUBORDINATES,
  APPROVE_IDP_LEARNING,
  GET_SUMMARY_IDP_SOCIAL_LEARNING,
  ADD_SOCIAL_LEARNING,
  GET_SUMMARY_IDP_EXPERIENTIAL_LEARNING,
  CREATE_PROJECT_ACTIVITY,
  UPDATE_PROJECT_ACTIVITY,
  DELETE_PROJECT_ACTIVITY,
  ACTION_PROJECT,
  GET_LIST_EMPLOYEE,
  ADD_PROJECT_EXPERIENTIAL_LEARNING,
} from "@/api/idp/enrollment";
import { GET_COACHING_BY_COMPETENCY } from "@/api/master-data/coaching/coaching";
import { GET_COMPETENCIES, GET_COMPETENCY_BY_NIK } from "@/api/master-data/competency/competency";
import { GET_TRAINING_METHOD } from "@/api/master-data/training-method/training-method";
import { GET_TRAINING_TYPE } from "@/api/master-data/training-type/training-type";

const handleRequest = async (apiFunc, commit, mutation, args, emptyValue = []) => {
  try {
    const resp = await apiFunc(args);
    const { httpCode, data } = resp.data;

    if (httpCode === 200) {
      if (data?.data && data?.totalItems !== undefined) {
        commit(mutation, {
          data: data.data,
          totalItems: data.totalItems,
          page: data.page,
          limit: data.limit,
          totalPages: data.totalPages,
        });
      } else {
        commit(mutation, data);
      }
      return data;
    }

    commit(mutation, emptyValue);
    return emptyValue;
  } catch (err) {
    const resp = err?.response?.data;
    if (resp?.httpCode === 404) {
      commit(mutation, emptyValue);
    }
    throw err;
  }
};

const state = {
  idpLearnings: {
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  idpLearningReport: {
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  structuredLearningDetail: null,
  socialLearningDetail: null,
  experientialLearningDetail: null,
  summaryIdpLearning: null,
  summaryIdpLearningReport: null,
  trainingMethods: [],
  trainingTypes: [],
  competencies: [],
  subordinates: [],
  subordinatesMeta: {
    totalItems: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  employeeCompetencies: [],
  listCoaching: [],
  employees: [],
};

const mutations = {
  setIdpLearnings: (state, payload) => {
    state.idpLearnings = {
      data: payload.data ?? [],
      totalItems: payload.totalItems ?? 0,
      page: payload.page ?? 1,
      limit: payload.limit ?? 10,
      totalPages: payload.totalPages ?? 1,
    };
  },
  setIdpLearningReport: (state, payload) => {
    state.idpLearningReport = {
      data: payload.data ?? [],
      totalItems: payload.totalItems ?? 0,
      page: payload.page ?? 1,
      limit: payload.limit ?? 10,
      totalPages: payload.totalPages ?? 1,
    };
  },
  setStructuredLearningDetail: (state, payload) => (state.structuredLearningDetail = payload),
  setSocialLearningDetail: (state, payload) => (state.socialLearningDetail = payload),
  setExperientialLearningDetail: (state, payload) => (state.experientialLearningDetail = payload),
  summaryIdpLearning: (state, payload) => (state.summaryIdpLearning = payload),
  summaryIdpLearningReport: (state, payload) => (state.summaryIdpLearningReport = payload),
  setTrainingMethods: (state, payload) =>
    (state.trainingMethods = payload?.map((item) => ({ value: item.id, label: item.name })) || []),
  setTrainingTypes: (state, payload) =>
    (state.trainingTypes = payload?.map((item) => ({ value: item.id, label: item.name })) || []),
  setCompetencies: (state, payload) =>
    (state.competencies = payload?.data?.map((item) => ({ value: item.id, label: item.name })) || []),
  setSubordinates: (state, payload) => {
    const rows = Array.isArray(payload) ? payload : payload?.data || [];
    state.subordinates = rows.map((item) => ({ ...item, text: `${item.name} - ${item.nik}`, value: item.nik }));
    state.subordinatesMeta = {
      totalItems: Array.isArray(payload) ? rows.length : payload?.totalItems ?? rows.length,
      page: Array.isArray(payload) ? 1 : payload?.page ?? 1,
      limit: Array.isArray(payload) ? rows.length || 10 : payload?.limit ?? 10,
      totalPages: Array.isArray(payload) ? 1 : payload?.totalPages ?? 1,
    };
  },
  setEmployeeCompetencies: (state, payload) => (state.employeeCompetencies = payload),
  setListCoaching: (state, payload) => (state.listCoaching = payload),
  setEmployees: (state, payload) => (state.employees = payload),
  resetIdpLearnings: (state) => {
    state.idpLearnings = {
      data: [],
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
    };
  },
  resetIdpLearningReport: (state) => {
    state.idpLearningReport = {
      data: [],
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
    };
  },
  resetSummaryIdpLearning: (state) => (state.summaryIdpLearning = null),
};

const actions = {
  async getIdpLearnings({ commit }, query) {
    return handleRequest(GET_LIST_IDP_LEARNING, commit, "setIdpLearnings", query, []);
  },

  async getIdpLearningReport({ commit }, query) {
    return handleRequest(GET_LIST_IDP_LEARNING, commit, "setIdpLearningReport", query, []);
  },

  async getStructuredLearningDetail({ commit }, { id, query }) {
    return handleRequest(GET_DETAIL_STRUCTURED_LEARNING, commit, "setStructuredLearningDetail", { id, query }, null);
  },

  async getSocialLearningDetail({ commit }, { id, query }) {
    return handleRequest(GET_DETAIL_SOCIAL_LEARNING, commit, "setSocialLearningDetail", { id, query }, null);
  },

  async getExperientialLearningDetail({ commit }, { id, query }) {
    return handleRequest(GET_DETAIL_EXPERIENTIAL_LEARNING, commit, "setExperientialLearningDetail", { id, query }, null);
  },

  async submitIdpLearning(_, { query, data }) {
    return SUBMIT_IDP_LEARNING(query, data);
  },

  async addSocialLearning(_, { data }) {
    return ADD_SOCIAL_LEARNING(data);
  },

  async approveIdpLearning(_, { query, data }) {
    return APPROVE_IDP_LEARNING(query, data);
  },

  async createProjectExperientialLearning(_, { data }) {
    return ADD_PROJECT_EXPERIENTIAL_LEARNING(data);
  },

  async createProjectActivity(_, { data }) {
    return CREATE_PROJECT_ACTIVITY(data);
  },

  async updateProjectActivity(_, { id, data }) {
    return UPDATE_PROJECT_ACTIVITY({ id, data });
  },

  async deleteProjectActivity(_, { id }) {
    return DELETE_PROJECT_ACTIVITY(id);
  },

  async actionExperientialLearning(_, { data }) {
    return ACTION_PROJECT(data);
  },

  async getSummaryIdpLearning({ commit }, query) {
    const resp = await handleRequest(GET_SUMMARY_IDP_LEARNING, commit, "summaryIdpLearning", query, null);
    return resp;
  },

  async getSummaryIdpSocialLearning({ commit }, query) {
    const resp = await handleRequest(GET_SUMMARY_IDP_SOCIAL_LEARNING, commit, "summaryIdpLearning", query, null);
    return resp;
  },

  async getSummaryIdpSocialLearningReport({ commit }, query) {
    const resp = await handleRequest(GET_SUMMARY_IDP_SOCIAL_LEARNING, commit, "summaryIdpLearningReport", query, null);
    return resp;
  },

  async getSummaryIdpLearningReport({ commit }, query) {
    const resp = await handleRequest(GET_SUMMARY_IDP_LEARNING, commit, "summaryIdpLearningReport", query, null);
    return resp;
  },

  async getSummaryIdpExperientialLearning({ commit }, query) {
    const resp = await handleRequest(GET_SUMMARY_IDP_EXPERIENTIAL_LEARNING, commit, "summaryIdpLearning", query, null);
    return resp;
  },

  async getSummaryIdpExperientialLearningReport({ commit }, query) {
    const resp = await handleRequest(GET_SUMMARY_IDP_EXPERIENTIAL_LEARNING, commit, "summaryIdpLearningReport", query, null);
    return resp;
  },

  async getIdpPeriod() {
    const response = await GET_IDP_PERIOD();
    return response.data.data;
  },

  async getTrainingMethods({ commit }, id) {
    return handleRequest(GET_TRAINING_METHOD, commit, "setTrainingMethods", id, null);
  },

  async getTrainingTypes({ commit }, id) {
    return handleRequest(GET_TRAINING_TYPE, commit, "setTrainingTypes", id, null);
  },

  async getCompetencies({ commit }, id) {
    return handleRequest(GET_COMPETENCIES, commit, "setCompetencies", id, null);
  },

  async getSubordinates({ commit }, query) {
    return handleRequest(GET_SUBORDINATES, commit, "setSubordinates", query, null);
  },

  async getEmployeeCompetencies({ commit }, id) {
    return handleRequest(GET_COMPETENCY_BY_NIK, commit, "setEmployeeCompetencies", id, null);
  },

  async getCoachingByCompetency({ commit }, id) {
    return handleRequest(GET_COACHING_BY_COMPETENCY, commit, "setListCoaching", id, null);
  },

  async getEmployees({ commit }, id) {
    return handleRequest(GET_LIST_EMPLOYEE, commit, "setEmployees", id, null);
  },

  resetIdpLearnings({ commit }) {
    commit("resetIdpLearnings");
    commit("resetSummaryIdpLearning");
    commit("resetIdpLearningReport");
  },
};

const getters = {
  idpLearnings: (state) => state.idpLearnings,
  idpLearningReport: (state) => state.idpLearningReport,
  structuredLearningDetail: (state) => state.structuredLearningDetail,
  socialLearningDetail: (state) => state.socialLearningDetail,
  experientialLearningDetail: (state) => state.experientialLearningDetail,
  summaryIdpLearning: (state) => state.summaryIdpLearning,
  summaryIdpLearningReport: (state) => state.summaryIdpLearningReport,
  trainingMethods: (state) => state.trainingMethods,
  trainingTypes: (state) => state.trainingTypes,
  competencies: (state) => state.competencies,
  subordinates: (state) => state.subordinates,
  subordinatesMeta: (state) => state.subordinatesMeta,
  employeeCompetencies: (state) => state.employeeCompetencies,
  listCoaching: (state) => state.listCoaching,
  employees: (state) => state.employees,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
